import { render } from "./AccountBankUpdate.vue?vue&type=template&id=5dffb8ce"
import script from "./AccountBankUpdate.vue?vue&type=script&lang=js"
export * from "./AccountBankUpdate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__